import createApp from "./src/app";

const { app, router, store } = createApp();

// 客户端激活:用 SSR 注入的 __INITIAL_STATE__ 替换 store,避免重复请求
// 但要保留客户端持久化的 user 模块(登录态),因为 SSR 拿不到 localStorage
if (window.__INITIAL_STATE__) {
  const ssrState = window.__INITIAL_STATE__;
  // 合并:用 SSR 数据覆盖 page_one 等,但 user 模块用客户端 localStorage 恢复的值
  const mergedState = {
    ...ssrState,
    user: { ...ssrState.user, ...store.state.user },
  };
  store.replaceState(mergedState);
}

router.onReady(() => {
  // 首屏:对当前匹配组件调 asyncData
  // - SSR 模式:已有 __INITIAL_STATE__,这里不重复调(数据已就绪)
  // - npm run serve 模式:没有 __INITIAL_STATE__,这里触发 asyncData 拿数据
  const hasInitialState = !!window.__INITIAL_STATE__;
  const onReady = () => {
    // 路由切换时,客户端预取"新出现组件"的 asyncData
    router.beforeResolve((to, from, next) => {
      const matched = router.getMatchedComponents(to);
      const prevMatched = router.getMatchedComponents(from);
      let diffed = false;
      for (let i = 0; i < matched.length; i++) {
        if (matched[i] !== prevMatched[i]) {
          diffed = true;
          break;
        }
      }
      if (!diffed) {
        return next();
      }

      Promise.all(
        matched
          .filter((c) => c && c.asyncData)
          .map((c) => c.asyncData({ store, route: to }))
      )
        .then(() => next())
        .catch(next); // 失败不阻断导航,页面降级
    });

    app.$mount("#app");
  };

  if (hasInitialState) {
    // SSR 模式:数据已由服务端注入,直接挂载
    onReady();
  } else {
    // SPA 模式(npm run serve):首屏主动调 asyncData 拿数据
    const matched = router.getMatchedComponents();
    Promise.all(
      matched
        .filter((c) => c && c.asyncData)
        .map((c) => c.asyncData({ store, route: router.currentRoute }))
    )
      .then(() => onReady())
      .catch(() => onReady()); // 失败也挂载,降级显示
  }
});
